
export function init_fadeAnimation() {
  // ページが読み込まれたときに一度だけフェードイン効果を適用する
  function applyFadeOnLoad() {
    const targets = document.querySelectorAll('.js-fade-in');
    targets.forEach((target) => {
      const fromTop = target.getBoundingClientRect().top;
      const scroll = window.scrollY || document.documentElement.scrollTop;
      const offset = fromTop + scroll;
      const innerHeight = window.innerHeight;
      if (scroll > (offset - innerHeight)) {
        target.classList.add('is-faded');
      }
    });
  }
  // ページが読み込まれたときにフェードイン効果を適用
  applyFadeOnLoad();

  // スクロール時にフェードイン効果を適用
  window.addEventListener('scroll', () => {
    const targets = document.querySelectorAll('.js-fade-in');
    targets.forEach((target) => {
      const fromTop = target.getBoundingClientRect().top;
      const scroll = window.scrollY || document.documentElement.scrollTop
      const offset = fromTop + scroll;
      const innerHeight = window.innerHeight;
      if (scroll > (offset - innerHeight)) {
        target.classList.add('is-faded');
      } else {
        target.classList.remove('is-faded');
      }
      if (scroll == 0) {
        target.classList.remove('is-faded');
      }
    });
  });
};